export function getGeolocation() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(pos => {
      let position = pos.coords;
      resolve(position);
      reject(() => {
        alert("error");
      });
    });
  });
}
